import validate from "/app/node_modules/nuxt/dist/pages/runtime/validate.js";
import _001_45dictionary_45global from "/app/src/middleware/001.dictionary.global.ts";
import manifest_45route_45rule from "/app/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  _001_45dictionary_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}